import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { Table, Tooltip } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link, useParams } from "react-router";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ListOfSeasons() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const params = useParams();
  const [id, setId] = useState("");
  const detail = $api.useQuery("get", "/site-api/v1/course-detail/", {
    params: {
      query: {
        course_u_id: params.id ?? "",
      },
    },
    headers: {
      Authorization: tokenMock,
      lang: "fa",
    },
  });
  const { data, isPending, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/course-season/",
    {
      params: {
        query: {
          course_u_id: params.id ?? "",
        },
      },
    },
  );
  const removeCategory = $api.useMutation(
    "delete",
    "/site-api/v1/course-season/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("فصل ها");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteCourseSeasonItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان فصل",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "مدت زمان ویدیو",
      dataIndex: "duration",
      key: "duration",
    },
    {
      title: "تعداد ویدیو",
      dataIndex: "video_count",
      key: "video_count",
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          <Tooltip title="لیست ویدیو های فصل">
            <ButtonLinkIcon
              to={`/video-list/${record.u_id}`}
              icon="solar:videocamera-broken"
              className="text-primary-500!"
            />
          </Tooltip>
          {/* <ButtonLinkIcon
            to={{
              pathname: `/add-season/${params.id}`,
              search: `?u_id=${record.u_id}&name=${detail?.data?.data?.title}`,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: `/add-season/${params.id}`,
              search: `?u_id=${record.u_id}&name=${detail?.data?.data?.title}`,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={removeCategory.isPending}
        title="حذف از نظرات ویژه ؟"
        description="حذف این نظر باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          removeCategory.mutate(
            {
              params: {
                query: {
                  season_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                setIsOpen(false);
                notify.success(data.message);
                setId("");
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-between sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <CustomBreadcrumb
          items={[
            {
              title: "دوره ها",
              href: "/courses",
            },
            {
              title: detail?.data?.data?.title,
            },
          ]}
        />
        <Link to={`/add-season/${params.id}`} className="button-style">
          ایجاد فصل
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteCourseSeasonItem"]>
            columns={columns}
            dataSource={data?.data}
            loading={isPending}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
